<template>
	<div class='lg-category'>
		<div class='lg-category-header'>
			<div v-for="(item,index) in category_list" :key="index" class="category-list">
				<span
						:class="active_category[index] === str.id ?'category-list-item is-active':'category-list-item'"
						v-for="str in item"
						:key="str.id"
						@click="handleSelectCategory(str,index)"
				>
					{{str.name}}
				</span>
			</div>
		</div>

	</div>
</template>

<script>
  export default {
    name: "index",
    props:['category_list','active_category'],
    data() {
      return {
      }
    },
    methods: {
      handleSelectCategory(data,index){
        let info = {
          data:data,
          index:index
        }
        this.$emit('select',info)

      }
    }
  }
</script>

<style scoped lang='less'>
	.lg-category{
		&-header{
			background-color: #FFFFFF;
			padding: 10px 240px 0;
			.category-list{
				padding: 10px 0 ;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				border-bottom: 1PX solid #F4F4F4;
				&-item{
					margin-left: 20px;
					color: #8d92a1;
					font-size: 14px;
					cursor: pointer;
				}
				&-item:first-child{
					margin-left: 0;
				}
				.is-active{
					background-color: #ffde00;
					padding: 2px 5px;
					border-radius: 4px;
					color: #ffffff;
				}
			}
			.category-list:last-child{
				border: 0;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/category/index.vue